import "../style/toast.scss";
/**
 * toast提示
 * @param {*} options time: 显示时间 callback：显示结束后回调 maskVisible:是否显示遮罩层
 */
export const Toast = (msg = "", options = {}) => {
    let { time = 2000, callback, maskVisible = true } = options;
    if ($("#toast-h5").length) {
        $("#toast-h5").hide().remove();
    }
    let classN = `toast-mask ${maskVisible ? "" : "no-mask"}`;
    let newDom = `<div id="toast-h5" class=${classN}>
    <div class="toast-outer">
    <div class="toast-inner">
        <div class="toast-text">${msg}</div>
      </div></div>
    </div>`;
    $(newDom).appendTo($("body"));
    let timer = setTimeout(() => {
        $("#toast-h5").hide().remove();
        clearTimeout(timer);
        callback && callback();
    }, time);
};
